export default __webpack_public_path__ + "images/6208517b9795f3fb026806c2adb256cb.png";